import { render, staticRenderFns } from "./DynamicMainActionField.vue?vue&type=template&id=1f041828&scoped=true"
import script from "./DynamicMainActionField.vue?vue&type=script&lang=ts"
export * from "./DynamicMainActionField.vue?vue&type=script&lang=ts"
import style0 from "./DynamicMainActionField.vue?vue&type=style&index=0&id=1f041828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f041828",
  null
  
)

export default component.exports